<script setup lang="ts">
import {ConsumerProduct} from "@/consumer/interfaces";
import {onMounted, ref} from "vue";
import {drugInteractionApi} from "@/container";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";

const props = defineProps<{
    customerId: number;
    products: ConsumerProduct[];
}>();

defineEmits<{
    (e: 'next'): void;
}>();
const htmlContent = ref<string>('');
const loading = ref(false);

const loadHTML = async () => {
    loading.value = true;
    try {
        htmlContent.value = await drugInteractionApi().HTMLInteractions(
            props.products.map(p => p.product.cip),
            props.customerId
        );
    } finally {
        loading.value = false;
    }
};

onMounted(() => loadHTML());
</script>

<template>
  <BaseFlexSpinner v-if="loading" />

  <div v-else class="flex-1 flex flex-col gap-4">
    <iframe
      :srcdoc="htmlContent"
      sandbox="allow-same-origin allow-scripts"
      class="w-full flex-1"
    />
    <BaseButton class="self-end" primary @click="$emit('next')">
      Suivant
    </BaseButton>
  </div>
</template>

<style scoped>

</style>
